import { Injectable } from '@angular/core';
import { PractitionerAPIResponse, Practitioner } from '../interfaces/practitioner';
import { IdentifierAPIResponse } from '../interfaces/identifier';
import { AddressAdapter } from './address.adapter';
import { QualificationAdapter } from './qualification.adapter';
import { TelecomAdapter } from './telecom.adapter';

@Injectable({
  providedIn: 'root',
})
export class PractitionerAdapter {
  constructor(private addressAdapter: AddressAdapter, private qualificationAdapter: QualificationAdapter, private telecomAdapter: TelecomAdapter) {}

  public adapterToModel(practitionerFHIR: PractitionerAPIResponse): Practitioner {
    const identifier = this.extractIdentifiers(practitionerFHIR.identifier);
    const telecom = this.telecomAdapter.adapterToModel(practitionerFHIR?.telecom!);
    const address = this.addressAdapter.adapterToModel(practitionerFHIR.address[0]);
    const qualifications = this.qualificationAdapter.adapterToModel(practitionerFHIR?.qualification);

    const model: Practitioner = {
      practitioner_id: practitionerFHIR.practitioner_id,
      name: practitionerFHIR.name,
      gender: practitionerFHIR.gender,
      birthDate: practitionerFHIR.birthDate,
      email: telecom.email ?? '',
      cpf: identifier.CPF ?? '',
      mobile: telecom?.mobile ?? undefined,
      phone: telecom?.phone ?? undefined,
      avatar: undefined,
      active: practitionerFHIR.active,
      address: address,
      qualifications: qualifications.qualifications,
      certificates: qualifications.certifications,
      communication: practitionerFHIR.communication,
      token_id: practitionerFHIR.token_id,
      accessibilities: practitionerFHIR.accessibilities,
      photo: practitionerFHIR.photo,
      modifiedDays: practitionerFHIR.modifiedDays ?? [],
    };

  
    if (practitionerFHIR.created_by_organization?.organization_id) {
      model["created_by_organization"] = {
        organization_id: practitionerFHIR.created_by_organization.organization_id,
        organization_name: practitionerFHIR.created_by_organization.organization_name ?? null
      };
    }

    return model;
  }

  public adaptToAPIFormat(practitionerModel: Practitioner): PractitionerAPIResponse {
    const apiFormat: PractitionerAPIResponse =  {
      practitioner_id: practitionerModel.practitioner_id ?? '"1233455"',
      name: practitionerModel.name,
      avatar: undefined,
      identifier: [{ value: practitionerModel.cpf, system: 'CPF' }],
      gender: practitionerModel.gender,
      birthDate: practitionerModel.birthDate,
      telecom: this.telecomAdapter.adaptToAPIFormat(practitionerModel.email, practitionerModel.phone, practitionerModel.mobile),
      qualification: practitionerModel.qualifications
        ? this.qualificationAdapter.adaptToAPIFormat(practitionerModel.qualifications, practitionerModel.certificates)
        : [],
      address: practitionerModel.address ? this.addressAdapter.adaptToAPIFormat(practitionerModel.address) : [],
      communication: practitionerModel.communication ?? [],
      active: practitionerModel.active,
      token_id: practitionerModel.token_id,
      accessibilities: practitionerModel.accessibilities,
      photo: practitionerModel.photo,
      modifiedDays: practitionerModel?.modifiedDays ?? [],
    };

    if (practitionerModel.created_by_organization?.organization_id) {

      console.log(practitionerModel.created_by_organization)
      apiFormat["created_by_organization"] = {
        organization_id: practitionerModel.created_by_organization.organization_id,
        organization_name: practitionerModel.created_by_organization.organization_name ?? null
      };
    }

    return apiFormat;

  }

  private extractIdentifiers(identifiers: IdentifierAPIResponse[]) {
    let CPF: string | null = null;
    let CRM: string | null = null;
    let CNPJ: string | null = null;

    identifiers.forEach((identifier) => {
      const { system, value } = identifier;

      if (system === 'CPF') {
        CPF = value;
      } else if (system === 'CRM') {
        CRM = value;
      } else if (system === 'CNPJ') {
        CNPJ = value;
      }
    });

    return { CPF, CRM, CNPJ };
  }
}
